import { Notification } from "./Notification";

export interface NotificationRequest{
    id: number;
    title: string;
    message: string;
    validFrom: Date;
    putOnTop: boolean;
    isActive: boolean;
    roleIds: number[];
    attachmentIds: number[];   
}

export function createNotificationRequestFromNotification(notification: Notification): NotificationRequest {
    return {
        id: notification.id,
        title: notification.title,
        message: notification.message,
        validFrom: notification.validFrom!,
        putOnTop: notification.putOnTop,
        isActive: notification.isActive,
        roleIds: notification.roles,        
        attachmentIds: notification.attachments?.map(a => a.id!) ?? [] as number[]        
    }
}